import { 
  Box,
  Skeleton,
  Grid,
  Typography,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { Assessment } from "../../../models/assessments";
import { useStudentActions } from "../../../hooks/useStudentActions";
import { useEffect, useState } from "react";
import LoadingSkeleton from "../../../components/loading-skeleton";
import { AssessmentPreviewCard } from "./components/preview-card";
import AccessExpired from "../../../components/access-expired";

export default function Assessments() {
  const { classroom_id } = useParams<{ classroom_id: string }>();
  

  const [loading, setLoading] = useState(false);

  const {
    classrooms, 
    getClassrooms,
    getAssessments
  } = useStudentActions();

  const classroom = classrooms?.[Number(classroom_id)];

  useEffect(() => {
    const loadAssessments = async () => {
      await getAssessments(Number(classroom_id));
    };

    setLoading(true);
    if (classroom && !classroom.assessments) loadAssessments();
    setLoading(false);
  }, [classroom, classroom_id]);

  if (!classroom || !classroom.assessments || loading) {
    return (<LoadingSkeleton/>);
  }

  if (classroom.expiry_date && new Date() >= new Date(classroom.expiry_date)) {
    return <AccessExpired classroom_id={classroom_id!}/>
  }

  const assessmentList = Object.values(classroom.assessments);
  
  return (
    <Box>
      {assessmentList.length === 0 ? (
        <Box
          sx={{
            textAlign: "center",
            py: 6,
            color: "text.secondary",
          }}
        >
          <Typography variant="h6" fontWeight={500}>
            No assessments available
          </Typography>
        </Box>
      ) : (
        <Grid container spacing={2}>
          {assessmentList
            .sort((a, b) => new Date(b.last_updated).getTime() - new Date(a.last_updated).getTime())
            .map((assessment) => (
              <Grid key={assessment.id} size={{ xs: 12, md: 6, lg: 4 }}>
                <AssessmentPreviewCard assessment={assessment}/>
              </Grid>
            ))}
        </Grid>
      )}
     
    </Box>
  );
}
